<template>
    <div class="loadingState" :class="{ overlay: overlay, responsive: props.responsive }" :style="outerStyle">
        <div class="flex">
            <StaticImage v-if="overlay && !small" class="datalaneLogo" filename="pac-logo.svg"></StaticImage>
            <ProgressSpinner :style="spinStyle" />
        </div>
        <div v-if="userMessage">{{ userMessage }}</div>
    </div>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
    overlay: {
        type: Boolean,
        default: false,
    },
    small: {
        type: Boolean,
        default: false,
    },
    zIndex: {
        type: Number,
        default: 1102,
    },
    responsive: {
        type: Boolean,
        default: false,
    },
    heightOffset: {
        default: '- 15px',
    },
    widthOffset: {
        default: '- 15px',
    },
    userMessage: {
        type: String,
    }
});
const outerStyle = computed(() => {
    if (!props.overlay) {
        return {};
    }
    return {
        zIndex: props.zIndex,
        height: `calc(100% ${props.heightOffset})`,
        width: `calc(100% ${props.widthOffset})`,
    };
});
const spinStyle = computed(() => {
    if (props.small) {
        return { width: "15px", height: "15px" };
    }
    if (props.responsive) {
        return { width: "100%", height: "100%" };
    }
    return {};
});
</script>
<style scoped>
.loadingState.overlay {
    top: 0;
    left: 0;
    margin: auto;
    background-color: #fff;
    position: absolute;
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.loadingState.responsive {
    width: 100%;
    height: 100%;
    aspect-ratio: 1 / 1;
    max-width: 100%;
    max-height: 100%;
}

.datalaneLogo {
    max-width: 300px;
    width: 75%;
}
.overlay :deep(.p-progress-spinner) {
    margin: unset;
}
</style>
